import { Alert, Snackbar, SnackbarCloseReason } from "@mui/material";
import React, { useEffect, useState, SyntheticEvent } from "react";

interface Props {
	message: string | null;
	onHide: () => void;
}

export const NotificationSnackBar = ({ message, onHide = () => {} }: Props) => {
	const handleClose = (
		event: Event | SyntheticEvent<any, Event>,
		reason?: SnackbarCloseReason,
	) => {
		if (reason === "clickaway") {
			return;
		}
		onHide();
	};
	const [open, setOpen] = useState(true);
	useEffect(() => {
		setOpen(message !== "" && message !== null);
	}, [message]);

	return (
		<Snackbar open={open} autoHideDuration={2500} onClose={handleClose}>
			<Alert elevation={6} severity="success" onClose={handleClose}>
				{message}
			</Alert>
		</Snackbar>
	);
};
